import "@opendaw/lib-std";
import { ObjectField, NoPointers, Int32Field, Float32Field, BooleanField, } from "@opendaw/lib-box";
export class PianoMode extends ObjectField {
    static create(construct) {
        return new PianoMode(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get keyboard() {
        return this.getField(1);
    }
    get timeRangeInQuarters() {
        return this.getField(2);
    }
    get noteScale() {
        return this.getField(3);
    }
    get noteLabels() {
        return this.getField(4);
    }
    get transpose() {
        return this.getField(5);
    }
    initializeFields() {
        return {
            1: Int32Field.create({
                parent: this,
                fieldKey: 1,
                fieldName: "keyboard",
                pointerRules: NoPointers,
            }, 0),
            2: Float32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "timeRangeInQuarters",
                pointerRules: NoPointers,
            }, 8),
            3: Float32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "noteScale",
                pointerRules: NoPointers,
            }, 1.5),
            4: BooleanField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "noteLabels",
                pointerRules: NoPointers,
            }, false),
            5: Int32Field.create({
                parent: this,
                fieldKey: 5,
                fieldName: "transpose",
                pointerRules: NoPointers,
            }, 0),
        };
    }
}
